
import { Component, Vue } from "vue-property-decorator";
import DataPlotList from "@/components/DataPlot/List.vue";
@Component({
  components: {
    DataPlotList,
  },
})
export default class DataPlotIndex extends Vue {}
